module.exports = __webpack_public_path__ + "static/media/veryvell_2.4b2c3a98.png";